import { Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import MainLayout from "./layouts/MainLayout";
import Dashboard from "./pages/dashboard/Dashboard";
import Customers from "./pages/customers/Customers";
import Loans from "./pages/loans/Loans";
import Reports from "./pages/reports/Reports";
import Analytics from "./pages/reports/Analytics";
import TabularReports from "./pages/reports/TabularReports";
import Shares from "./pages/shares/Shares";
import Savings from "./pages/savings/Savings";
import ShareView from "./pages/shares/ShareView";
import Transactions from "./pages/transactions/Transactions";
import Settings from "./pages/settings/Settings";
import UserManagement from "./pages/userManagement/UserManagement";
import Login from "./pages/login/Login";
import Customer from "./pages/customers/Customer";
import CustomerTransactions from "./pages/customers/CustomerTransactions";
import NewPassword from "./pages/set-password/NewPassword";
import Verification from "./pages/verification/Verification";
import RequireAuth from "./components/auth/RequireAuth";
import Unauthorized from "./components/auth/Unauthorized";
import Loan from "./pages/loans/Loan";
import IntroBulk from "./pages/bulk-repayment/IntroBulk";
import BulkRepayments from "./pages/bulk-repayment/BulkRepayments";
import ProcessingRepayments from "./pages/bulk-repayment/ProcessingRepayments";
import SummaryBulk from "./pages/bulk-repayment/SummaryBulk";
import Guarantors from "./pages/loans/Guarantors";
import SavingsView from "./pages/savings/SavingsView";
import SystemLogs from "./pages/auditlogs/SystemLogs";
// import SystemLogs from "./pages/logs/SystemLogs";
import { initSession } from "./hooks/logoutUser";

function App() {
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };

    initSession();

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);
  const ROLES = {
    master_admin: 2000,
    super_admin: 1999,
    customer_admin: 2001,
  };
  return (
    <main>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/new-password" element={<NewPassword />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route element={<MainLayout />} path="/dashboard">
          {/* dashboard main */}
          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  ROLES.customer_admin,
                  ROLES.master_admin,
                  ROLES.super_admin,
                ]}
              />
            }
          >
            <Route element={<Dashboard />} index />
          </Route>

          {/* customers */}
          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  ROLES.customer_admin,
                  ROLES.master_admin,
                  ROLES.super_admin,
                ]}
              />
            }
          >
            <Route element={<Customers />} path="/dashboard/customers" />
          </Route>
          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  ROLES.customer_admin,
                  ROLES.master_admin,
                  ROLES.super_admin,
                ]}
              />
            }
          >
            <Route element={<Customer />} path="/dashboard/customers/:id" />
          </Route>
          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  ROLES.customer_admin,
                  ROLES.master_admin,
                  ROLES.super_admin,
                ]}
              />
            }
          >
            <Route
              element={<CustomerTransactions />}
              path="/dashboard/customers/:id/:accountId"
            />
          </Route>
          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route element={<Loans />} path="/dashboard/loans" />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route element={<Guarantors />} path="/dashboard/guarantors" />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route
              element={<Loan />}
              path="/dashboard/loans/:loanCode/:customerId/:loanType"
            />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route element={<Shares />} path="/dashboard/shares" />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route element={<Savings />} path="/dashboard/savings" />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route element={<ShareView />} path="/dashboard/shares/:memberId" />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route
              element={<SavingsView />}
              path="/dashboard/savings/:memberId"
            />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route element={<Reports />} path="/dashboard/reports" />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route
              element={<TabularReports />}
              path="/dashboard/reports/:reportType/:reportKey"
            />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route element={<Analytics />} path="/dashboard/analytics" />
          </Route>

          {/* <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route element={<SystemLogs />} path="/dashboard/audit-trail" />
          </Route> */}

          <Route
            element={
              <RequireAuth
                allowedRoles={[ROLES.master_admin, ROLES.super_admin]}
              />
            }
          >
            <Route element={<Transactions />} path="/dashboard/transactions" />
          </Route>
          <Route
            element={
              <RequireAuth
                allowedRoles={[ROLES.master_admin, ROLES.super_admin]}
              />
            }
          >
            <Route element={<IntroBulk />} path="/dashboard/bulk-repayment" />
          </Route>
          <Route
            element={
              <RequireAuth
                allowedRoles={[ROLES.master_admin, ROLES.super_admin]}
              />
            }
          >
            <Route
              element={<BulkRepayments />}
              path="/dashboard/bulk-repayment/preview"
            />
          </Route>
          <Route
            element={
              <RequireAuth
                allowedRoles={[ROLES.master_admin, ROLES.super_admin]}
              />
            }
          >
            <Route
              element={<ProcessingRepayments />}
              path="/dashboard/bulk-repayment/update-records"
            />
          </Route>
          <Route
            element={
              <RequireAuth
                allowedRoles={[ROLES.master_admin, ROLES.super_admin]}
              />
            }
          >
            <Route
              element={<SummaryBulk />}
              path="/dashboard/bulk-repayment/summary"
            />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route element={<Settings />} path="/dashboard/settings" />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.super_admin]} />}>
            <Route
              element={<UserManagement allowedRoles={[]} />}
              path="/dashboard/userManagement/users"
            />
            <Route
              element={<SystemLogs allowedRoles={[]} />}
              path="/dashboard/userManagement/audit-trail"
            />
          </Route>
        </Route>
      </Routes>
    </main>
  );
}

export default App;
